import { useState } from "react";
import { AddIcon } from "../../../assets/icons";
import { GetAccess } from "../../../utils/RolesandAccess";
import UseGetData from "../../../hooks/useFetchData";
import { RoleLoader } from "../../../components/Loader";
import CreateorUpdate from "./form";
import Viewmore from "./viewMore";

function RoleIndex() {
  let { data, isLoading,getData } = UseGetData({
    url: `/Role-Permission/get_by_role`,
  });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showMyMenu, setShowMyMenu] = useState(false);
  const handleOnCloseMenu = () => setShowMyMenu(false);
  

  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            Role
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                <AddIcon />
              </div>
            )}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          <div className="lg:w-[50%] mt-2 border border-black mx-auto  px-3 rounded-lg">
            {isLoading == true ? (
              <>
                {[...Array(8)].map((_, index) => {
                  return <RoleLoader />;
                })}
              </>
            ) : (
              <>
              {
                data?.map((item,idx)=>{
                  return (
                    <div className="flex justify-between my-3" key={idx}>
                     <p className="text-xs py-1">{item?.roleName}</p>
                     <Viewmore
                        onClose={handleOnCloseMenu}
                        visible={showMyMenu}
                        data={item}
                        fetcher={getData}
                      />
                    </div>
                  )
                })
              }
              </>
            )}
          </div>
        </div>
      </div>
      <CreateorUpdate
          onClose={handleOnClose}
          visible={showMyModal}
          refreshData={getData}
        />
    </>
  );
}

export default RoleIndex;
